"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncWoocommerceForm = void 0;
class SyncWoocommerceForm {
    static init() {
        const firstForm = document.querySelector('.product .summary .variations_form');
        const secondForm = document.querySelector('.product-information .configure-block .variations_form');
        if (!firstForm || !secondForm) {
            return;
        }
        this.syncForms(firstForm, secondForm);
        this.syncForms(secondForm, firstForm);
    }
    static syncForms(source, target) {
        source.addEventListener('change', (event) => {
            const el = event.target;
            if (el && el.tagName === 'SELECT') {
                const name = el.name;
                const val = el.value;
                const targetEl = target.querySelector(`select[name="${name}"]`);
                if (targetEl && targetEl.value !== val) {
                    targetEl.value = val;
                    targetEl.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        });
        source.addEventListener('click', (event) => {
            const sourceElement = event.target;
            if (sourceElement && sourceElement.classList.contains('swatch')) {
                const targetSelect = target.querySelector('select#pa_kleur');
                const value = sourceElement.dataset.value;
                const targetSwatches = target.querySelectorAll('.swatch');
                if (!value || !targetSelect || !targetSwatches) {
                    return;
                }
                if (targetSelect.value !== value) {
                    targetSelect.value = value;
                    targetSwatches === null || targetSwatches === void 0 ? void 0 : targetSwatches.forEach((swatch) => {
                        swatch.classList.remove('selected');
                        if (swatch.dataset.value === targetSelect.value) {
                            swatch.classList.add('selected');
                        }
                    });
                }
                if (sourceElement.classList.contains('selected')) {
                    targetSelect.value = '';
                    targetSwatches === null || targetSwatches === void 0 ? void 0 : targetSwatches.forEach((swatch) => {
                        swatch.classList.remove('selected');
                    });
                }
                targetSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }
}
exports.SyncWoocommerceForm = SyncWoocommerceForm;
